<div class="screen-element day-planner-overview">
	<div #titleElement [ngStyle]="{'opacity':titleopacity}" class="text title">{{getTitle()}}</div>

		<div class="marker"></div>

	<div #wrapElement [ngStyle]="{'top':top}" class="menu-elements-wrap">
	<div *ngFor="let el of menuElements">
		<div class="menu-row" [ngClass]="{'active':el==currentElement,nobox:true}">
			<div class="menu-item">
				<span *ngIf="el.icon" class="icon inline-icon {{el.icon}}"></span>
				<span class="">{{el.getTitle()}}</span>
			</div>
		</div>
	</div>
	</div>
</div>